export default __webpack_public_path__ + "static/media/mobile-app-development.8e0d9cd0.jpg";